import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { MaritalStatusType } from '../../../../../core/domain/data';

@JsonConverter
export class MaritalStatusAdapter implements JsonCustomConvert<MaritalStatusType | undefined> {
    serialize(type: MaritalStatusType): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): MaritalStatusType | undefined {
        switch (type) {
            case 'E':
                return MaritalStatusType.CHOOSE;
            case '':
                return MaritalStatusType.CHOOSE;
            case 'S':
                return MaritalStatusType.SINGLE;
            case 'C':
                return MaritalStatusType.MARRIED;
            default:
                return MaritalStatusType.OTHER;
        }
    }
}
